<div *ngIf="showList()" class="container-fluid pl-0 pr-0">  
    <div class="card p-3">
        <h3 class="font-weight-lighter f-18">{{ 'projectstage.header' | trans }}</h3>
            <div class="row mb-1">
                <div class="col-6 col-md">
                    <p class="mb-0 cursor-default font-weight-lighter">{{ 'projectstage.orgname' | trans }}</p>
                </div>
                <div class="col-3 col-md">
                    <p class="mb-0 cursor-default font-weight-lighter">{{ 'projectstage.relation' | trans }}</p>
                </div>
                <div class="d-none d-sm-none d-md-block col">
                    <p class="mb-0 cursor-default font-weight-lighter">{{ 'projectstage.requesteddate' | trans }}</p>
                </div>
                <div class="col-3 col-md">
                    <p class="mb-0 cursor-default font-weight-lighter">{{ 'projectstage.joineddate' | trans }}</p>
                </div>
                <div class="d-none d-sm-none d-md-block col">
                    <p class="mb-0 cursor-default font-weight-lighter">{{ 'projectstage.exitdate' | trans }}</p>
                </div>
            </div>
            <div *ngFor="let personorg of PersonorgList" class="row pt-2 pb-2">
                <div class="col-6 col-md">
                    <p data-toggle="modal" (click)="getOrgDetail(personorg)" data-target="#orgviewModal" 
                    matTooltip="{{ 'projectstage.showdetailsof' | trans }}{{ personorg.organization}}" matTooltipPosition="above" 
                    matTooltipShowDelay="500" class="mb-0 cursor-pointer">{{ personorg.organization }}</p>
                </div>
                <div class="col-3 col-md">
                    <p matTooltip="{{ 'projectstage.relationtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" 
                    class="mb-0 cursor-default">{{ personorg.relationtype }}</p>
                </div>
                <div class="d-none d-sm-none d-md-block col">
                    <p matTooltip="{{ 'projectstage.daterequested' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" 
                    class="mb-0 cursor-default">{{ personorg.date_requested | date:'yyyy-MM-dd' }}</p>
                </div>
                <div class="col-3 col-md">
                    <p matTooltip="{{ 'projectstage.datejoined' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" 
                    class="mb-0 cursor-default">{{ personorg.date_joined | date:'yyyy-MM-dd' }}</p>
                </div>
                <div class="d-none d-sm-none d-md-block col">
                    <p matTooltip="{{ 'projectstage.dateleft' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" 
                    class="mb-0 cursor-default">{{ personorg.date_left | date:'yyyy-MM-dd' }}</p>
                </div>
            </div> 
     </div>
</div>
<div class="container"> 
    <div id="orgviewModal" class="modal fade" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <!-- Modal content-->
            <div class="modal-content">
                 <div class="modal-header">
                     <h6 class="modal-title cursor-default">{{ orgDetail.organizationname }}</h6>
                     <button type="button" class="close" data-dismiss="modal" (click)="cleanup()" >&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-auto">
                            <img class="rounded" src="{{orgDetail.logourl}}" onerror="this.src='../../assets/images/org_blank.png';">
                        </div>
                        <div class="col">
                            <p class="mb-0 cursor-default" >{{ orgDetail.email}}</p>
                            <p class="mb-0 cursor-default" >{{ orgDetail.address}}</p>
                            <p class="mb-0 cursor-default" >{{ orgDetail.city}}</p>
                            <p class="mb-0 cursor-default" >{{ orgDetail.zip}}</p>
                            <p class="mb-0 cursor-default" >{{ orgDetail.country}}</p>
                                     <a class="cursor-pointer" href="{{orgDetail.www}}">
                                        <span class="material-icons f-20 opacity lh-30 align-middle cursor-pointer text-muted">
                                            public
                                        </span>
                                    </a>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <p class="mb-0 cursor-default" >{{ orgDetail.orgdesc}}</p>
                        </div>
                    </div>
            <div class="row">
                <div *ngIf="leaver" class="alert alert-danger w-100" role="alert">
                    {{ 'projectstage.breakwarning' | trans }}
                  </div>
                <div *ngIf="inOrg()" class="col">
                    <button *ngIf="leaver" (click)="leaveOrg()"  class="btn-close">
                        <h6 class="btn-save-text">{{ 'projectstage.confirmbreak' | trans }}</h6>
                    </button>
                    <button *ngIf="!leaver"(click)="leaverF()"  class="btn-close">
                        <h6 class="btn-save-text">{{ 'projectstage.breaklink' | trans }}</h6>
                    </button>
                </div>
                <div *ngIf="!inOrg()" class="col">
                    <button (click)="reJoin()" class="btn-save">
                        <h6 class="btn-save-text">{{ 'projectstage.relink' | trans }}</h6>
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>    
    </div>
</div>
   